import React from 'react';
import { Input, Textarea, Select, Button, PaperClip, DatePicker } from 'components';
import moment from 'moment';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { Menu as MenuIcons, CompanyIcon, MessageIcon } from 'assets/icons';
import { RouteComponentProps } from 'react-router-dom';
import Home from './home';
import Message from './message';
import Retargeting from './retargeting';
import Human from './human';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const TABS = {
	HOME: 1,
	MESSAGE: 2,
	RETARGETING: 3,
	HUMAN: 4
}

class Agent extends React.Component<Props> {

	state = {
		items: [
			{ icon: MenuIcons.AgentIcon1, name: 'Agente', value: TABS.MESSAGE },
			{ icon: MenuIcons.AgentIcon2, name: 'Empresa', value: TABS.HOME },
			{ icon: MenuIcons.AgentIcon3, name: 'Retargeting', value: TABS.RETARGETING },
			{ icon: MenuIcons.AgentIcon4, name: 'Redirigir a humano', value: TABS.HUMAN }
		],
		item: TABS.MESSAGE
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Accionar del Agente',
				onBack: null
			}
		});
	}

	goTo = (item: any) => {
		this.setState({
			item: item?.value
		});
	}

	render() {
		const { items, item } = this.state;

		return (
			<div id="client-agent">
				<div className="row">
					<div className="col-md-3">
						{
							items.map((item: any) => {
								return (
									<button className={ `btn btn-menu ${ item.value == this.state.item ? 'active' : '' }` } onClick={ () => this.goTo(item) }>
										<img src={ item.icon } />
										<p>{ item.name }</p>
									</button>
								)
							})
						}
					</div>
					<div className="col-md-9">
						{
							item == TABS.HOME && (
								<>
									{/*
									// @ts-ignore */}
									<Home />
								</>
							)
						}

						{
							item == TABS.MESSAGE && (
								<>
									{/*
									// @ts-ignore */}
									<Message />
								</>
							)
						}

						{
							item == TABS.RETARGETING && (
								<>
									{/*
									// @ts-ignore */}
									<Retargeting />
								</>
							)
						}

						{
							item == TABS.HUMAN && (
								<>
									{/*
									// @ts-ignore */}
									<Human />
								</>
							)
						}
					</div>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Agent);